export default __webpack_public_path__ + "static/media/Standard20.0113642d.png";